import gql from "graphql-tag";
import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
export const promoPlansQuery = gql `
  query promoPlansQuery {
    promoPlans {
      amount
      name
      id
      interval
      tasks
      tiers {
        numTasks
        pricePerTask
      }
      type
      zaps
    }
  }
`;
export const usePromoPlans = (props) => {
    var _a;
    const useQuery = (props === null || props === void 0 ? void 0 : props.useQuery) || defaultUseQuery;
    const { data, error, loading } = useQuery(promoPlansQuery, {});
    const promoPlans = (_a = data === null || data === void 0 ? void 0 : data.promoPlans) !== null && _a !== void 0 ? _a : [];
    return {
        allowIntervalSelection: promoPlans.length > 0,
        error: error
            ? "Error getting promo plans for this user. Please try again."
            : undefined,
        isLoading: loading,
        promoPlans,
    };
};

// @zapier/upsells@5.0.1 (c64b11b3c)
